export const collectClerkEmails = user => {
	if (!user) return []
	const values = [user.primaryEmailAddress?.emailAddress]
	const list = user.emailAddresses || []
	list.forEach(item => {
		values.push(item?.emailAddress)
	})
	return [
		...new Set(
			values
				.map(value => String(value || '').trim().toLowerCase())
				.filter(Boolean),
		),
	]
}

export const isAlreadySignedInError = err => {
	const clerkErr = err?.errors?.[0]
	const code = String(clerkErr?.code || '')
	const message = String(
		clerkErr?.longMessage || clerkErr?.message || err?.message || '',
	)
	return (
		code === 'session_exists' ||
		code === 'identifier_already_signed_in' ||
		/already signed in/i.test(message)
	)
}

/**
 * After counselor-auth-methods succeeds, decide what to do with a Clerk session
 * that is already open.
 * absent: no session, start a new Clerk sign-in.
 * enter: session belongs to the checked email.
 * mismatch: session belongs to someone else.
 * unknown: a session exists but identity is not readable yet.
 */
export function decideExistingClerkSession({
	user,
	sessionId,
	userId,
	expectedEmail,
} = {}) {
	const sid = String(sessionId || '').trim()
	const uid = String(userId || user?.id || '').trim()
	const expected = String(expectedEmail || '').trim().toLowerCase()

	if (!sid && !uid) return { action: 'absent' }
	if (!sid || !uid) return { action: 'unknown' }

	const emails = collectClerkEmails(user)
	if (!emails.length) return { action: 'unknown' }
	if (!expected || !emails.includes(expected)) return { action: 'mismatch' }

	return { action: 'enter', sessionId: sid, userId: uid, email: expected }
}
